import { useDispatch, useSelector } from "react-redux";
import { setTokenInStore } from './tokenTPSlice'
// import { setTenantStore, setTenantNull } from "./tenantSlice";
import { jwtDecode } from "jwt-decode";
import { useCallback, useEffect, useState } from "react";
import { setAlertMsgStore } from "./alertMsgSlisce";
import { useGetPersonWhoamiDataMutation, usePostLoginMutation, usePostUserTokenMutation } from "./CallTPApi";
import { setOrderInStore } from "./orderTPSlice";
import { Token } from "../interface/Token";
import { useSearchParams } from "react-router-dom";
import { setWhoamitStore } from "./whoamiTPSlice";
import { setTokenAuthenticationInStore } from "./tokenAuthenticationTPSlice";
import { Tenant } from "../interface/Tenant";
import { setFeatureStore } from "./featureSlice";
import { setRolesStore } from "./rolesSlice";

const TOKEN_REFRESH_BUFFER = 5 * 60; // 5 минут в секундах до истечения токена
const TOKEN_CHECK_INTERVAL = 60 * 1000; // Проверка каждую минуту

const getDistributor = () => {
    switch (window.location.host) {
        case 'localhost:44449':
            return '585498ce-52d1-46bb-b3e7-6f91dbc92cd7';
        case '192.168.4.13:44449':
            return '585498ce-52d1-46bb-b3e7-6f91dbc92cd7';
        case '10.10.163.46:44449':
            return '585498ce-52d1-46bb-b3e7-6f91dbc92cd7';
        default:
            // return '585498ce-52d1-46bb-b3e7-6f91dbc92cd7';
            return '3a2c2f37-9b4e-48a6-8098-6b33059e988b';
    }
}

export const useTokenTP = () => {
    const [isAuthentication, setIsAuthentication] = useState<boolean>(false)
    const dispatch = useDispatch()
    const token = useSelector((state: any) => state.tokenTP?.value) as Token;
    const [postUserToken] = usePostUserTokenMutation()
    const [postLogin] = usePostLoginMutation()
    const [searchParams] = useSearchParams()
    const [getPersonWhoamiData] = useGetPersonWhoamiDataMutation()

    useEffect(() => {
        console.log(token)
        if (token) {
            const strToken = token as string;
            const decode = jwtDecode(strToken) as any;
            const expToken = decode.exp
            if (expToken) {
                getPersonWhoamiData().then((res: any) => {
                    if (res.data) {
                        dispatch(setWhoamitStore(res.data))
                    }
                })
                const now = Math.floor(Date.now() / 1000);
                if (now < expToken) {
                    // Проверка истечения срока действия токена и запрос нового токена за 5 минут до истечения
                    const timeToRefresh = (expToken - now - 5 * 60) * 1000; // Время до обновления в миллисекундах
                    if (timeToRefresh > 0) {
                        const refreshTimeout = setTimeout(() => {
                            // Здесь вы можете сделать запрос нового токена
                            postUserToken(null).then((res: any) => {
                                if (!res.error) {
                                    setTokenTP(res.data.token)
                                } else {
                                    dispatch(setAlertMsgStore({ variant: 'warning', title: "Ошибка авторизации, попробуйте еще раз" } as any))
                                    // window.alert("Ошибка авторизации, попробуйте еще раз")
                                    // setIsAuthentication(false)
                                    logOutTP()
                                }
                            })
                        }, timeToRefresh);
                        return () => clearTimeout(refreshTimeout); // Очистка таймера при размонтировании компонента
                    }
                }
            }

        }
    }, [token])

    // Получение информации о токене
    const getTokenInfo = useCallback((tokenString: string) => {
        try {
            const decoded = jwtDecode(tokenString) as any;
            const expToken = decoded.exp;
            const now = Math.floor(Date.now() / 1000);

            if (!expToken) return null;
            return {
                decoded,
                expTimestamp: expToken,
                timeUntilExp: expToken - now,
                shouldRefresh: (expToken - now) <= TOKEN_REFRESH_BUFFER,
                isExpired: now >= expToken
            };
        } catch (error) {
            console.error('Token decoding error:', error);
            return null;
        }
    }, []);

    const setTokenTP = async (token: string) => {

        if (token === "" || token === undefined) {
            return;
        }
        if (checkTokenExp(token)) {
            setTokenInLocalStorage(token)
            const tokenData = {
                value: token,
            }
            dispatch(setTokenInStore(tokenData))
            const tokenInfo = await getTokenInfo(token) as any;
            const roles = tokenInfo.decoded?.role;
            const features = tokenInfo.decoded?.feature;
            console.log(tokenInfo.decoded)
            console.log(features)
            console.log(roles)

            if (roles) {
                const rolesArray = Array.isArray(roles) ? roles : [roles.toString()];
                dispatch(setRolesStore(rolesArray as any));
                dispatch(setFeatureStore(rolesArray as any));
            }

            if (features) {
                if (!roles) {
                    dispatch(setRolesStore(features));
                }
                dispatch(setFeatureStore(features));
            }
        }
    }

    const setTokenAuthenticationTP = (token: string) => {
        if (token === "") {
            return;
        }
        if (checkTokenExp(token)) {
            setTokenAuthInLocalStorage(token)
            const tokenData = {
                value: token,
            }
            dispatch(setTokenAuthenticationInStore(tokenData))
        }
    }

    const setDistributorTP = async (getToken = false as boolean) => {
        // const distributorId = searchParams.get("distributorId")
        const distributorId = getDistributor()
        console.log(distributorId)
        if (!distributorId) {
            return;
        }
        postLogin({ distributorId: distributorId } as any).then((res: any) => {
            if (res.data) {
                console.log(res.data)
                const tenantData = {
                    id: res.data.tenantId,
                } as Tenant;
                localStorage.setItem("tenantIdTP", res.data.tenantId)
                localStorage.setItem("tenantDataTP", JSON.stringify(tenantData))

                if (getToken) {
                    setTokenTP(res.data.token)
                    setTokenAuthenticationTP(res.data.token)
                }
            }
            if (res.error) {
                // dispatch(setAlertMsgStore({
                //     title: "Нет доступа по ссылке",
                //     variant: "danger"
                // } as any))
            }
        })
    }


    const checkTokenExp = (token: string) => {
        if (token === "") {
            localStorage.removeItem('tokenTP')
            localStorage.removeItem('tenantIdTP')
            return false;
        }
        const decode = jwtDecode(token) as any;
        const expToken = decode.exp
        const distributorId = decode.DistributorId
        if (expToken) {
            const now = Math.floor(Date.now() / 1000);
            if (now < new Date(expToken).getTime()) {
                return true;
            }
            else {
                localStorage.removeItem('tokenTP')
                localStorage.removeItem('tokenAuthenticationTP')
                localStorage.removeItem('tenantIdTP')
                localStorage.removeItem('orderTP')
                localStorage.removeItem('sessionIdTP')
                dispatch(setOrderInStore(null as any))
                return false
            }
        }
        else {
            return false;
        }
    }

    const setTokenInLocalStorage = (data: string) => {
        localStorage.setItem('tokenTP', data)
    }
    const setTokenAuthInLocalStorage = (data: string) => {
        localStorage.setItem('tokenAuthenticationTP', data)
    }

    const updateTokenTP = async () => {
        setIsAuthentication(true)
        const tokenAuthentication = localStorage.getItem('tokenAuthenticationTP')
        if (tokenAuthentication != null && checkTokenExp(tokenAuthentication)) {
            const tenantData = localStorage.getItem('tenantDataTP')
            setTokenTP(tokenAuthentication)
            setTokenAuthenticationTP(tokenAuthentication)
            setDistributorTP()
            if (tenantData !== null) {
                const tenant: any = JSON.parse(tenantData);
                if (tenant) {
                    await postUserToken(null).then((res: any) => {
                        if (!res.error) {
                            setTokenTP(res.data.token)
                        } else {
                            dispatch(setAlertMsgStore({ variant: 'warning', title: "Ошибка авторизации, попробуйте еще раз" } as any))
                            // window.alert("Ошибка авторизации, попробуйте еще раз")
                            // setIsAuthentication(false)
                            logOutTP()
                        }
                    })
                }
            }
        }
        else {
            await setDistributorTP(true)
        }
        setIsAuthentication(false)
    }

    const logOutTP = (reload: boolean = true) => {
        // Очищаем локальное хранилище
        const storageKeys = [
            'tenantDataTP',
            'tokenAuthenticationTP',
            'tokenTP',
            'orderTP',
            'sessionIdTP'
        ];
        storageKeys.forEach(key => localStorage.removeItem(key));

        // Сбрасываем состояние Redux
        dispatch(setOrderInStore(null as any));
        dispatch(setTokenInStore(null));
        dispatch(setTokenAuthenticationInStore(null));
        // Перезагружаем страницу при необходимости
        if (reload) {
            window.location.reload();
        }
    };

    return {
        token,
        setTokenAuthenticationTP,
        setTokenTP,
        logOutTP,
        updateTokenTP,
        isAuthentication,
        setIsAuthentication
    }
}




